<!--  -->
<template>
    <div class='left2_container box_v box_between'>
        <div class="title1  box">解决问题</div>
        <div class="content box box_f1">
            <div v-for="(item,index) in list" :key="`resolve_${index}`" class="item box box_between">
                <div class="title box">{{item.typeName}}</div>
                <div class="number box">{{item.count}}{{handelTag}}</div>
                    
            </div>
        </div>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
    //这里存放数据
        return {
            list:[],
            handelTag:'件'
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        getData(){
            this.$get(this.urlobj.resolveNumberByType).then(res=>{
                let maxNum = res.rows[0].count
                this.list = res.rows.map(item=>{
                    return{
                        typeName:item.typeName,
                        count:maxNum>10000?(item.count/10000).toFixed(2):item.count,
                    }
                })
                this.handelTag = maxNum>10000?'万件':'件'
            })
        }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getData()
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.left2_container{
    width: 100%;
    background-image: url('../../../../assets/images/monitorpy/leftcenter.png');
    background-size: 100% 100%;
    height:100%;
}
.title1{
    font-size: 18px;
    font-weight: bold;
    color: #FFFFFF;
    margin:20px 0 0 40px
}
.content{
    padding:5px 0px 0 0px;
    flex-wrap: wrap;
    max-height:240px;
    .item{
        width:45%;
        height:20%;
        max-height: 34px;
        align-items: center;
        margin:0 3%;
        box-shadow:0 0 5px #008cff inset; 
        //margin-bottom:10px
    }
   .item:nth-child(odd){
        margin-right:2%
    }
    .item:nth-child(even){
        margin-left:2%
    }
    .title{
        font-size: 14px;
        color: #B3DDFF;
        margin-left:10px;
    }
    .number{
        text-align: right;
        font-size: 18px;
        font-weight: bold;
        font-style: italic;
        color: #FFFFFF;
        background: linear-gradient(0deg, #00FFD8 0%, #00C35C 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        padding-right:4px;
        margin-right:10px
    }
    
}
</style>